import { render, staticRenderFns } from "./mpyy.vue?vue&type=template&id=57f0ad94&scoped=true&"
import script from "./mpyy.vue?vue&type=script&lang=js&"
export * from "./mpyy.vue?vue&type=script&lang=js&"
import style0 from "./mpyy.vue?vue&type=style&index=0&id=57f0ad94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0ad94",
  null
  
)

export default component.exports